import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';

import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CountryService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('country', http, authentication);
  }

  listCountries() {
    return this.getRequest(`${this.url}/ddl`);
  }
  listAllCountries(){
    return this.getRequest(`${this.url}/list`);
  }
  listAllProvinces(){
    return this.getRequest(`${this.url}/province`);
  }

  listAllProvincesByCountryId(countryId){
    return this.getRequest(`${this.url}/getprovincebycountry/${countryId}`);
  }

}
